module.exports = __webpack_public_path__ + "static/img/104133.32772b62.png";